import { createSelector } from 'reselect'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getState = (state: any) => state.analytics

export const getTotalPaymentPeriodSelector = createSelector(
  getState,
  ({ totalPaymentPeriod }) => totalPaymentPeriod
)

export const getFirstPaymentPeriodSelector = createSelector(
  getState,
  ({ firstPaymentPeriod }) => firstPaymentPeriod
)

export const getRepeatedPaymentPeriodSelector = createSelector(
  getState,
  ({ repeatedPaymentPeriod }) => repeatedPaymentPeriod
)

export const getRequestsActivitySelector = createSelector(
  getState,
  ({ requestsActivity }) => requestsActivity
)
